export default {
  getUFs: (state) => {
    return state.ufs
  },
  getMunicipios: (state) => {
    return state.municipios
  },
  getMunicipiosPorEstado: (state) => (id) => {
    return state.municipios.filter(mn => mn.cdUf == id).sort().reverse()
  },
  getActiveRations: (state) => {
    return state.racoes.filter(entry => entry.flAtiva == true)
  },
  getValorTabela: (state) => (stChave) => {
    return state.tabelaConfiguracao != null ? state.tabelaConfiguracao.filter(i => i.stChave == stChave).length > 0 ?
      state.tabelaConfiguracao.filter(i => i.stChave == stChave) : '' : ''
  },
}